<template>
  <div class="section" :style="!isContentVisible ? {height: '337px !important'} : ''">
    <div
      class="background"
      :class="isBackground()"
      :style="{ backgroundImage: 'url(' + imageUrl + ')' }"
    ></div>
    <div
      class="main-content d-flex"
      :class="isBlack ? 'content-black' : 'content-white'"
    >
      <div :class="isContentVisible ? 'main-section-isContent' : 'main-section'">
        <h2
          :class="isContentVisible ? 'main-section-h2-isContent' : 'main-section-h2'"
        >
          {{ heading }}
        </h2>
        <h3
          v-if="!isContentVisible"
          class="main-section-h3 d-flex justify-center mb-3"
        >
          {{ subheading }}
        </h3>
        <v-btn
          :class="learnMoreBtnStyle()"
          @click="showContent"
          elevation="0"
        >
          {{ isContentVisible ? 'See Less' : 'Learn More' }}
        </v-btn>
      </div>

      <div
        v-if="isContentVisible"
        class="content-div"
      >
        <p class="section-content">{{ content }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent} from 'vue';

export default defineComponent({
  props: {
    imageUrl: String,
    heading: String,
    subheading: String,
    isFlip: Boolean,
    isOpaque: Boolean,
    content: String,
    isBlack: Boolean
  },
  data() {
    return {
      isContentVisible: false,
    }
  },
  methods: {
    showContent(){
      this.isContentVisible = !this.isContentVisible;
    },
    isBackground(){
      return [
        { flip: this.isFlip, opaque: this.isOpaque },
        this.isContentVisible ? (this.isBlack ? 'font-black' : 'font-white') : ''
      ];
    },
    learnMoreBtnStyle(){
      const baseClass = this.isContentVisible ? 'learn-more-btn-isContent' : 'learn-more-btn';
      const colorClass = this.isBlack ? 'learn-more-btn-black' : 'learn-more-btn-white';
      return `${baseClass} ${colorClass}`;
    }
  },
});
</script>

<style scoped>
.main-section{
  position: relative;
  width: 100%;
  display: grid;
  justify-content: center;
}
.main-section-isContent{
  position: relative;
  /* min-width: 300px; */
  min-width: 367px;
  display: grid;
  justify-content: normal;
  align-items: center;
}
.main-section-h2{
  font-size: 38px;
  font-weight: 550;
  font-family: 'Spartan', sans-serif;
  letter-spacing: 1px;
  justify-content: center;
  display: grid;
  margin-bottom: 20px;
}
.main-section-h2-isContent{
  font-size: 35px;
  font-weight: 600;
  font-family: 'Spartan', sans-serif;
  letter-spacing: 1px;
  text-align: center;
  line-height: 40px;
  margin-bottom: -75px;
}
.main-section-h3{
  font-size: 23px;
  font-weight: 500;
  letter-spacing: 1px;
}
.content-div{
  position: relative;
  width: 100%;
  display: grid;
  justify-content: center;
  padding: 35px;
  border-left: 2px solid;
}
.content-black{
  color: #000;
}
.content-white{
  color: #fff;
}
.main-section-isContent {
  transition: all 0.7s ease;
}
.main-section-h2-isContent {
  transition: all 0.7s ease;
}
.content-div {
  animation: slide-in-right 0.7s forwards;
}
.main-section-black{
  color: #000;
}
.main-section-white{
  color: #fff;
}
@keyframes slide-in-right {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}
@keyframes slide-out-right {
  from {
    transform: translateX(0);
    opacity: 1;
  }
  to {
    transform: translateX(100%);
    opacity: 0;
  }
}
.learn-more-btn{
  height: 32px;
  width: 93px;
  margin: 0 auto 20px auto;
  border-radius: 10px;
  background-color: transparent;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.10000000149011612px;
  text-transform: none;
}
.learn-more-btn-isContent{
  height: 32px;
  width: 93px;
  margin: 0 auto 20px auto;
  border-radius: 10px;
  background-color: transparent;
  font-size: 13px;
  font-weight: 400;
  letter-spacing: 0.10000000149011612px;
  text-transform: none;
}
.learn-more-btn-black {
  border: 1px solid #000;
  color: #000;
}
.learn-more-btn-white {
  border: 1px solid #fff;
  color: #fff;
}
.section {
  position: relative;
  overflow: hidden;
  padding: 0px;
  height: 337px;
  align-items: center;
  justify-content: center;
  display: flex;
}
.section-content{
  font-size: 17px;
  font-weight: 400;
  line-height: 28px;
  letter-spacing: 0.1px;
}
.background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-size: cover;
  background-position: center;
}
.font-white::before {
  content: '';
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.2); /* Semi-transparent black */
  z-index: 0;
}
.font-black{
  opacity: 0.5 !important;
}
.font-white{
  opacity: 1;
}
.flip{
  transform: scaleX(-1);
}
.opaque{
  opacity: 0.7; 
}
.main-content{
  display: flex;
}
@media (max-width: 1350px) {
  .section-content{
    font-size: 16px;
  }
  .main-section-h2{
    font-size: 35px;
  }
  .main-section-h3{
    font-size: 22px;
  }
  .content-div{
    padding: 28px;
  }
}
@media (max-width: 1200px) {
  .content-div {
    padding: 22px;
  }
}
@media (max-width: 1130px) {
  .main-content{
    display: flex;
    flex-direction: column;
  }
  .content-div {
    animation: none;
    padding: 19px;
    border-left: none;
  }
  .main-section-h2{
    font-size: 32px;
  }
  .main-section-h3{
    font-size: 20px;
  }
  .main-section-h2-isContent{
    margin-bottom: 0px;
    font-size: 29px;
  }
  .learn-more-btn-isContent{
    margin: 10px auto 0px auto;
    /* height: 20px; */
  }
}
@media (max-width: 990px) {
  .section{
    height: 380px;
  }
}
@media (max-width: 860px) {
  .section{
    height: 410px;
  }
}
@media (max-width: 760px) {
  .section-content{
    font-size: 15px;
  }
  .section{
    height: 440px;
    padding-top: 0px;
    padding-bottom: 0px;
  }
  .main-section-h2{
    font-size: 29px;
  }
  .main-section-h3{
    font-size: 19px;
  }
}
@media (max-width: 670px) {
  .section{
    height: 495px;
  }
}
@media (max-width: 650px) {
  .section-content{
    font-size: 14px;
  }
  .main-section-h2{
    font-size: 26px;
  }
  .main-section-h3{
    font-size: 18px;
  }
}
@media (max-width: 570px) {
  .section{
    height: 530px;
  }
}
</style>

